import { render, staticRenderFns } from "./VendorInventoryProductBansCell.vue?vue&type=template&id=d17fdfb4"
import script from "./VendorInventoryProductBansCell.vue?vue&type=script&lang=js"
export * from "./VendorInventoryProductBansCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports